import "./Navigation.css";

const Navigation = () => (
    <div className="nav big-font">
        <a id="title" href="/">ryguycompsci</a>
        <div>
            <a href="#about">about</a>
            <a href="#resume">resume</a>
            <a href="#connect">connect</a>
        </div>
    </div>
);

export default Navigation;
